import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-void text-ink-100">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-ink-500 hover:text-ink-100 mb-8"
        >
          <ArrowLeft size={16} /> Back to Home
        </Link>

        <div className="prose prose-invert prose-cyan max-w-none">
          <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
          <p className="text-ink-500 mb-8">Last Updated: May 12, 2026</p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">1. Agreement to Terms</h2>
            <p className="text-ink-300 leading-relaxed mb-4">
              By accessing or using MnemonicAI ("Service"), you agree to be bound by these Terms of Service ("Terms"). 
              If you disagree with any part of these terms, you may not access the Service.
            </p>
            <p className="text-ink-300 leading-relaxed">
              <strong>Company Information:</strong><br />
              Legal Name: MnemonicAI<br />
              Location: Melbourne, Victoria, Australia<br />
              Contact: mnemonicai.official@gmail.com
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">2. Description of Service</h2>
            <p className="text-ink-300 leading-relaxed mb-4">
              MnemonicAI provides AI agent memory infrastructure that enables artificial intelligence agents to capture, 
              reflect on, and recall lessons from past experiences. The Service includes:
            </p>
            <ul className="list-disc list-inside text-ink-300 space-y-2">
              <li>Memory storage and retrieval systems</li>
              <li>Reflection processing and lesson extraction</li>
              <li>API access for agent integration</li>
              <li>Dashboard and analytics tools</li>
              <li>Self-hosted and cloud-hosted deployment options</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">3. Acceptable Use Policy</h2>
            <p className="text-ink-300 leading-relaxed mb-4">
              You agree NOT to use the Service to:
            </p>
            <ul className="list-disc list-inside text-ink-300 space-y-2">
              <li>Violate any applicable laws</li>
              <li>Transmit harmful or objectionable content</li>
              <li>Attempt unauthorized access to systems</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Use the Service for illegal activities</li>
            </ul>
          </section>

          <section className="mb-8 border-l-4 border-amber pl-6">
            <h2 className="text-2xl font-bold mb-4">AI-Generated Content Disclaimer</h2>
            <p className="text-amber font-semibold mb-4">
              CRITICAL: READ CAREFULLY
            </p>
            <p className="text-ink-300 leading-relaxed mb-4">
              THE LESSONS, REFLECTIONS, AND CONTENT GENERATED BY AI ARE PROVIDED "AS IS" WITHOUT ANY WARRANTIES.
            </p>
            <p className="text-ink-300 leading-relaxed mb-4">
              AI-generated content may contain factual errors, be outdated, incomplete, biased, or provide incorrect advice.
            </p>
            <p className="text-ink-300 leading-relaxed">
              <strong>You are solely responsible for:</strong> Validating all AI-generated content before use, 
              verifying accuracy and safety, any decisions made based on AI content, and compliance with laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">4. Limitation of Liability</h2>
            <p className="text-ink-300 leading-relaxed mb-4">
              TO THE MAXIMUM EXTENT PERMITTED BY AUSTRALIAN LAW, WE ARE NOT LIABLE FOR ANY indirect, incidental, 
              special, or consequential damages including loss of profits, data, or business opportunities.
            </p>
            <p className="text-ink-300 leading-relaxed">
              Our total liability shall not exceed the amount you paid us in the 12 months before the claim, 
              or AUD $100, whichever is less.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">5. Mandatory Arbitration</h2>
            <p className="text-ink-300 leading-relaxed mb-4">
              Any dispute arising from these Terms shall be resolved by binding arbitration in Melbourne, Victoria, Australia.
            </p>
            <p className="text-ink-300 leading-relaxed">
              You waive any right to participate in class action lawsuits. All disputes must be brought individually.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">6. Contact</h2>
            <p className="text-ink-300 leading-relaxed">
              For questions about these Terms:<br />
              Email: <a href="mailto:mnemonicai.official@gmail.com" className="text-cyan-400 hover:underline">
                mnemonicai.official@gmail.com
              </a><br />
              Address: Melbourne, Victoria, Australia
            </p>
          </section>

          <div className="border-t border-line-1 pt-8 mt-12">
            <p className="text-sm text-ink-500">
              <a 
                href="/legal/TERMS_OF_SERVICE.md" 
                target="_blank"
                className="text-cyan-400 hover:underline"
              >
                View Full Terms of Service →
              </a>
            </p>
            <p className="text-xs text-ink-500 mt-4">
              Last Updated: May 12, 2026 | Version: 1.0
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
